/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */

import React, { memo } from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { PERCENTAGE_SYMBOL } from 'utils/constants';
import EVENTS from 'constants/analytics';
import Analytics from 'utils/analytics';
import {
  Modal,
  ModalHeader,
  ModalContent,
  Conditional,
  Text,
  RadioGroup,
  Button,
  InputField,
  Cross,
  InputWithAction,
} from '@cashfree-intl/coherent';
import FormikComponent from 'components/Formik';
import CustomIcon from 'components/CustomIcons';
import validationSchema, { validate } from './validation';
import {
  DYNAMIC,
  EPOS,
  FIXED,
  PG,
  PRODUCT_MAPPER,
  SBC,
  STATIC_QR,
  vendorSplitStructure,
} from '../constants';
import { addFieldToArray, removeFieldFromArray } from '../helper';

const radioData = {
  fieldLabel: 'Split Type',
  radioOptions: [
    {
      label: DYNAMIC,
      name: 'selected',
      value: false,
    },
    {
      label: FIXED,
      name: 'selected',
      value: true,
    },
  ],
};

export function EditModal({
  schemeData,
  verifyVendorId,
  onClose,
  createScheme,
}) {
  const initialValue = {
    ...schemeData,
    warning: false,
    vendorIdErrorList: Array(schemeData.scheme.length).fill(''),
    terminalRefIdSearch: schemeData.terminalRefId,
  };

  const handleFormSubmit = (
    {
      warning,
      terminalRefIdSearch,
      vendorIdErrorList,
      terminalIdList,
      ...rest
    },
    actions,
  ) => {
    actions.setSubmitting(true);
    const responseObj = {
      ...rest,
      scheme: rest.scheme.map(item => ({
        ...item,
        percentage: parseFloat(item.percentage),
      })),
    };
    if (rest.terminalId === '') responseObj.terminalId = '0';

    const cb = status => {
      if (status === 'success') {
        Analytics.track(EVENTS.SPLIT_SCHEME_CONFIGURATION.EDIT_SCHEME, {
          ...responseObj,
        });
        onClose();
      } else actions.setSubmitting(false);
    };
    createScheme({ ...responseObj, cb });
  };

  return (
    <Modal open className="common-modal-wrapper split-scheme-modal">
      <ModalHeader>
        Edit Split Configuration
        <Cross
          onClick={onClose}
          data-event-name="Form_EditSplitConfiguration_Icon_Close"
          data-ignore-inner-text="true"
        />
      </ModalHeader>
      <ModalContent>
        <div className="modal-content">
          <FormikComponent
            initialValues={{ ...initialValue }}
            enableReinitialize
            validationSchema={validationSchema}
            validateOnMount
            validate={validate()}
            onSubmit={handleFormSubmit}
          >
            {({
              values,
              handleFieldChange,
              handleSubmit,
              errors,
              touched,
              setValues,
              setFieldValue,
              handleFieldBlur,
              isSubmitting,
              dirty,
            }) => {
              const handleOptionalRadioOptions = obj => ({
                ...obj,
                checked: values.active === obj.value,
                onChange: () => {
                  setFieldValue('active', obj.value);
                },
              });

              const removeVendorById = index => {
                setValues({
                  ...values,
                  scheme: removeFieldFromArray(values.scheme, index),
                  vendorIdErrorList: removeFieldFromArray(
                    values.vendorIdErrorList,
                    index,
                  ),
                });
              };

              const addVendorById = () => {
                setValues({
                  ...values,
                  scheme: addFieldToArray(values.scheme, vendorSplitStructure),
                  vendorIdErrorList: addFieldToArray(values.vendorIdErrorList),
                });
              };

              const handleVendorIdBlur = (e, index) => {
                handleFieldBlur(e);

                const currentValue = values.scheme[index].merchantVendorId;
                if (currentValue !== '') {
                  setFieldValue('loading', true);
                  verifyVendorId({
                    vendorId: currentValue,
                    cb: status => {
                      const error =
                        status === 'error' ? 'Enter a valid VendorID' : '';
                      const newErrorList = [...values.vendorIdErrorList];
                      newErrorList[index] = error;
                      setValues({
                        ...values,
                        vendorIdErrorList: newErrorList,
                        loading: false,
                      });
                    },
                  });
                }
              };

              const disableFormSubmit = !dirty;

              const commissionPercentageError =
                touched.commissionPercentage && errors.commissionPercentage;

              return (
                <form onSubmit={handleSubmit}>
                  <div className="modal-body">
                    <div className="input-label">
                      <InputField
                        label="Product Type"
                        name="productType"
                        className="edit-product"
                        value={PRODUCT_MAPPER[values.productType]}
                        type="text"
                        placeholder="Select a Product"
                        onBlur={handleFieldBlur}
                        errors={errors}
                        touched={touched}
                        disabled
                      />
                    </div>
                    <Conditional if={values.productType === SBC}>
                      <div className="input-label">
                        <InputField
                          label="Reference ID"
                          name="terminalId"
                          className="edit-product"
                          value={values.terminalRefId}
                          type="text"
                          placeholder="Select Reference Id"
                          onBlur={handleFieldBlur}
                          errors={errors}
                          touched={touched}
                          disabled
                        />
                      </div>
                    </Conditional>
                    <Conditional if={values.productType !== ''}>
                      <div className="split-type">
                        <RadioGroup
                          fieldLabel={radioData.fieldLabel}
                          radioOptions={radioData.radioOptions.map(
                            handleOptionalRadioOptions,
                          )}
                        />
                      </div>

                      <Conditional if={!values.active}>
                        <Text variant="b14" color="warning">
                          To settle the amount to the vendor account, specify
                          split details in Create Order API or Split After
                          Payment API. Else, we will settle the amount to your
                          account.
                        </Text>
                      </Conditional>
                      <Conditional if={values.active}>
                        <Conditional
                          if={
                            values.productType === EPOS ||
                            values.productType === STATIC_QR
                          }
                        >
                          <div className="input-label">
                            <label>Commission Percentage</label>
                            <InputWithAction
                              name="commissionPercentage"
                              type="number"
                              label={{
                                basic: true,
                                content: PERCENTAGE_SYMBOL,
                              }}
                              value={values.commissionPercentage}
                              placeholder="Percentage"
                              onChange={handleFieldChange}
                              onBlur={handleFieldBlur}
                              errors={errors}
                              touched={touched}
                            />
                            {commissionPercentageError && (
                              <Text
                                variant="b12"
                                color="danger"
                                className="mt-1 ml-1"
                              >
                                {errors.commissionPercentage}
                              </Text>
                            )}
                          </div>
                        </Conditional>
                        <Conditional
                          if={
                            values.productType === PG ||
                            values.productType === SBC
                          }
                        >
                          <Text variant="h16" className="pb-2">
                            Vendor-wise Split Structure
                          </Text>
                          {values.scheme.map((data, index, array) => {
                            const vendorIdError =
                              touched.scheme?.[index]?.merchantVendorId &&
                              errors.scheme?.[index]?.merchantVendorId;

                            const percentageError =
                              touched.scheme?.[index]?.percentage &&
                              errors.scheme?.[index]?.percentage;

                            return (
                              <div className="vendor-group" key={index}>
                                <div className="input-label">
                                  <InputField
                                    label="Vendor Id"
                                    name={`scheme[${index}].merchantVendorId`}
                                    className={`vendor-input ${
                                      vendorIdError ||
                                      (values.vendorIdErrorList.length >
                                        index &&
                                        values.vendorIdErrorList[index] !== '')
                                        ? 'error-border'
                                        : ''
                                    }`}
                                    value={data.merchantVendorId}
                                    type="text"
                                    placeholder="Vendor Id"
                                    onChange={handleFieldChange}
                                    onBlur={e => handleVendorIdBlur(e, index)}
                                    errors={errors}
                                    touched={touched}
                                  />
                                </div>
                                <div className="input-label">
                                  <InputWithAction
                                    className="input-field-with-label"
                                    name={`scheme[${index}].percentage`}
                                    label={{
                                      basic: true,
                                      content: PERCENTAGE_SYMBOL,
                                    }}
                                    value={data.percentage}
                                    type="number"
                                    placeholder="Vendor Percentage"
                                    onChange={handleFieldChange}
                                    onBlur={handleFieldBlur}
                                    errors={errors}
                                    touched={touched}
                                  />
                                </div>
                                <div className="bin-item">
                                  {array.length > 1 && (
                                    <div
                                      className="table-cta-item"
                                      onClick={() => removeVendorById(index)}
                                    >
                                      <CustomIcon componentName="DELETE_SPLIT" />
                                    </div>
                                  )}
                                </div>
                                <div>
                                  {vendorIdError ? (
                                    <Text
                                      variant="b12"
                                      color="danger"
                                      className="mt-1"
                                    >
                                      {errors.scheme[index].merchantVendorId}
                                    </Text>
                                  ) : (
                                    values.vendorIdErrorList.length > index &&
                                    values.vendorIdErrorList[index] !== '' && (
                                      <Text
                                        variant="b12"
                                        color="danger"
                                        className="mt-1"
                                      >
                                        {values.vendorIdErrorList[index]}
                                      </Text>
                                    )
                                  )}
                                </div>
                                <div>
                                  {percentageError && (
                                    <Text
                                      variant="b12"
                                      color="danger"
                                      className="mt-1"
                                    >
                                      {errors.scheme[index].percentage}
                                    </Text>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                          <Conditional if={errors.totalPercentage}>
                            <Text variant="b12" color="danger" className="mt-1">
                              {errors.totalPercentage}
                            </Text>
                          </Conditional>
                          <Conditional if={errors.duplicatesExist}>
                            <Text variant="b12" color="danger" className="mt-1">
                              {errors.duplicatesExist}
                            </Text>
                          </Conditional>
                          <Conditional
                            if={
                              !errors.totalPercentage && !errors.duplicatesExist
                            }
                          >
                            <Button
                              type="button"
                              className="add-button"
                              onClick={() => addVendorById()}
                            >
                              + Add Vendor
                            </Button>
                          </Conditional>
                        </Conditional>
                      </Conditional>
                    </Conditional>
                  </div>
                  <div className="action-button">
                    <Button onClick={() => onClose()} link>
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      primary
                      disabled={disableFormSubmit}
                      loading={isSubmitting}
                    >
                      Save
                    </Button>
                  </div>
                </form>
              );
            }}
          </FormikComponent>
        </div>
      </ModalContent>
    </Modal>
  );
}

EditModal.propTypes = {
  schemeData: PropTypes.object.isRequired,
  verifyVendorId: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  createScheme: PropTypes.func.isRequired,
};
export default compose(memo)(EditModal);
